import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Contact from "./Pages/Contact/Contact";
import ContactAr from "./Pages/Contact/ContactAr";
import Error from "./Pages/Error/Error";
import HomeTwo from "./Pages/HomeTwo/HomeTwo/HomeTwo";
import HomeTwoAr from "./Pages/HomeTwo/HomeTwo/HomeTwoAr";
import Preloader from "./Pages/Preloader/Preloader";
import ScrollTop from "./Pages/ScrollTop/ScrollTop";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import PrivacyPolicyAr from "./Pages/PrivacyPolicy/PrivacyPolicyAr";


function App() {
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 2000);
  }, []);

  return (
    <>
      {loader && <Preloader />}
      <Router>
        <Routes>
          <Route path="/" element={<HomeTwo />} />
          <Route path="/Ar" element={<HomeTwoAr />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/privacy-policyar" element={<PrivacyPolicyAr />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contactar" element={<ContactAr />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </Router>
      <ScrollTop />
    </>
  );
}

export default App;
